import { useMutation, gql } from "@apollo/client"
import { IDENTITYPROVIDER_FIELDS } from "./useQueryIdentityProviders"

const CREATE_IDENTITYPROVIDER_MUTATION = gql`
  mutation CreateIdentityProvider($name: String!, $client: String!, $authority: String!, $browserPrompt: String, $devicePrompt: String) {
    createIdentityProvider(name: $name, client: $client, authority: $authority, browserPrompt: $browserPrompt, devicePrompt: $devicePrompt) {
      ${IDENTITYPROVIDER_FIELDS}
    } 
  }
`

const useMutationCreateIdentityProvider = () => useMutation(CREATE_IDENTITYPROVIDER_MUTATION)

export { useMutationCreateIdentityProvider }
